const Constants = {
  REQUEST_START_GAME: "REQUEST_START_GAME",
  REQUEST_GAME_STATUS: "REQUEST_GAME_STATUS",
  REQUEST_ADD_GAME_TIME: "REQUEST_ADD_GAME_TIME",
  REQUEST_UPDATE_TIMER: "REQUEST_UPDATE_TIMER"
};

export default Constants;



// WEBPACK FOOTER //
// ./src/components/lib/Constants.js